import React, { Component, PropTypes } from 'react';
// import '../../App.css';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import { BrowserRouter as Router,Route,Link} from 'react-router-dom'
import { openExtraModal,closeExtraModal,openTermsModal } from '../../actions/modals.js';
import { removeExtra, upsell_time_limit, upsell_editor_level } from '../../actions/paper.js';
import Extras from './Extras.js';
import calculatePrice from '../../util/calculatePrice';
import Terms from './Terms.js';
import { Field, reduxForm } from 'redux-form';
const fields = [ 'avatar' ];

const LoginForm = props => {
  const { fields: { avatar }, handleSubmit, pristine, reset, submitting , loginFailed, shouldShowGetStarted} = props;
  return (
    <div>
<div id="login-wrapper">
    <div>
        <div id="login-form" className="col-md-offset-3 col-md-6">
            <form onSubmit={handleSubmit}>
                <h2>Log In</h2>
                {(shouldShowGetStarted)? 
                    <p>
                        <a href="/get-started"><strong>New to Proofreading Manuscripts? Get Started by clicking here!</strong></a><br /><br />
                    </p>
                :
                    <p></p>
                }
                <label htmlFor="login-email">Email</label>
                <Field name="email" component="input" type="text"/><br/>
                <p>
                    <label htmlFor="login-pass">Password</label>
                    <Field name="password"  component="input" type="password"/>
                </p>
                <input type="hidden" name="token" value="" />
                <input type="hidden" name="action" value="login"/>
                {(loginFailed)? 
                    <div className="login-failed">Wrong email or password</div>
                :
                    <div></div>
                }
                <p>
                  <button type="submit" className="btn btn-default blue-button"> LOG IN </button>
                </p>
            </form>
           <p><a href="/forgot" id="forgot">Forgot password?</a></p>
           {(shouldShowGetStarted)? 
                <p>
                    <a href="/get-started"><strong>New to Proofreading Manuscripts? Get Started by clicking here!</strong></a><br /><br />
                </p>
                :
                <p></p>
           }
            <br /><br />
            <a href="https://proofreadingmanuscripts.com/examples/">See how we edit</a> or <a href="https://proofreadingmanuscripts.com/faq/">View our FAQ</a>

        </div>                                
    </div>
</div>
    </div>
  )
}

LoginForm.propTypes = {
//  fields: PropTypes.object.isRequired,
//  load: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
//  resetForm: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  loginFailed: PropTypes.bool.isRequired,
  shouldShowGetStarted: PropTypes.bool.isRequired
}

export default reduxForm({
  form: 'login-form-container',
  fields,
})(LoginForm);



// WEBPACK FOOTER //
// ./src/components/steps/loginform.js